

import {
    Component,
    OnInit,
  } from "@angular/core";
  import { NGXLogger } from "ngx-logger";
  import { ConfirmationService, MessageService } from "primeng/api";


  import {
    DialogService,
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";


import { Subject } from "rxjs";
import { StoricoPratica } from "src/app/models/pratica.storico.model";
import { StiliService } from "src/app/services/stili.service";
import { UtilService } from "src/app/services/util.service";
import { ExcelService } from "src/app/services/excelService.service";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { NotaPratica } from "src/app/models/pratica.nota.model";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PraticheService } from "src/app/services/pratiche.service";
import { Utente } from "src/app/models/utente.model";



@Component({
    selector: "component-storico-note",
    templateUrl: './note-pratica.component.html',
    styleUrls: ["../shared.component.css"],
  })
  export class StoricoNotePraticaComponent implements OnInit {


    protected _onDestroy = new Subject<void>();

    protected listaNote:NotaPratica[]=[];
    protected pratica: PraticaFlowdy2_Firestore;
    protected fase:number = 1;
    protected isNuovaNota:boolean = false;
    public isDemo: boolean                      = false;
    protected ref: DynamicDialogRef;
    isLoadingResults = false;
    protected aggiungiNotaForm: FormGroup;

    constructor(
        private logger: NGXLogger,
        public dialogRef: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public confirmationService:ConfirmationService,
        public dialogService: DialogService,
        private stiliService:StiliService ,
        private utilService:UtilService,
        private excelService:ExcelService,
        private formBuilder: FormBuilder,
        private praticheService:PraticheService,
        private messageService: MessageService,
      ) {
        if(localStorage.getItem("ruolo") && localStorage.getItem("ruolo") === "DEMO"){
          this.isDemo = true;
        }
        this.listaNote  = this.config.data.note;
        this.pratica    = this.config.data.pratica;
        this.logger.info(this.listaNote);
    }

   
    ngOnInit(): void {
    this.aggiungiNotaForm = this.formBuilder.group({
        contenuto:             [ null, [Validators.required]]
      });


    }
    aggiungiNota() {
      this.isNuovaNota = true;
    /*   this.listaNote.unshift({
        id:0,
        utente: null,
        data: new Date(),
        contenuto: '',
      }); */
      
    }

    salvaNota(){
      this.isLoadingResults = true;
      let nuovaNota:NotaPratica = new NotaPratica();
        nuovaNota.contenuto =  this.aggiungiNotaForm.get('contenuto').value;
        let utente:Utente = new Utente();
        utente.id = Number(localStorage.getItem("idUtente"));
        nuovaNota.utente = utente;
        this.logger.info(nuovaNota);
        this.praticheService.creaNota(this.pratica.id, nuovaNota).subscribe( {
          next: (res) => {
            this.isLoadingResults = false;
            this.messageService.add({severity:'success', summary:'', detail:'Nota creata con successo!', life:3000});
            this.isNuovaNota = false;
            this.listaNote = [];
            this.praticheService.getNote(this.pratica.id).subscribe(notePratica=>{
              this.listaNote = notePratica;
            });
            this.aggiungiNotaForm = this.formBuilder.group({
              contenuto:             [ null, [Validators.required]]
            });
          },  error: (e) => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "info",
              summary: "Errore" , life:10000,
                detail: "Errore in fase di creazione di una nota per la pratica!",
              });
          },
          complete: () => {

          }
        });
  
    }

    scaricaReportNote(){
      this.isLoadingResults = true;
      this.excelService.exportNotePraticaToExcel(this.listaNote, 'note_pratica_'+this.pratica.cui+'.xlsx');
      this.isLoadingResults = false;
     /*  if(this.fase === 1){
        this.excelService.exportStoricoToExcel(this.storico, 'storico_fase1_'+this.pratica.cui+'.xlsx');
      }else if(this.fase === 2){
        this.excelService.exportStoricoToExcel(this.storico, 'storico_fase2_'+this.pratica.cui+'.xlsx');
      }else if(this.fase === 3){
        this.excelService.exportStoricoToExcel(this.storico, 'storico_fase3_'+this.pratica.cui+'.xlsx');
      }  */
    }
    
  }
